import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	status: "",
	colors: [],
};

const filterSlice = createSlice({
	name: "filters",
	initialState,
	reducers: {
		setStatus: (state, action) => {
			state.status = action.payload;
		},
		setColors: (state, action) => {
			const { color, changeType } = action.payload;

			switch (changeType) {
				case "added":
					state.colors.push(color);
					break;
				case "removed":
					state.colors = state.colors.filter((col) => col !== color);
					break;
				default:
					break;
			}
		},
	},
});

export default filterSlice.reducer;
export const { setColors, setStatus } = filterSlice.actions;
